import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhoneCallbackComponent } from "./med-icon-phone-callback.component";

@NgModule({
  declarations: [
    MedIconPhoneCallbackComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhoneCallbackComponent,
  ],
})
export class MedIconPhoneCallbackModule { }
